import api from './BaseApi';

export const createPickupZone = async (data) => {
    try {
        const response = await api.post('/admin/pickup-zones', data);
        return response;
    } catch (error) {
        console.error('Create pickup zone error:', error);
        return error;
    }
};

export const getPickupZones = async (params) => {
    try {
        const response = await api.get('/admin/pickup-zones', { params });
        return response.data;
    } catch (error) {
        console.error('Get pickup zones error:', error);
    }
};

export const getPickupZoneById = async (id) => {
    try {
        const response = await api.get(`/admin/pickup-zones/${id}`);
        return response.data;
    } catch (error) {
        console.error('Get pickup zone error:', error);
    }
};

export const updatePickupZone = async (id, payload) => {
    try {
        const response = await api.put(`/admin/pickup-zones/${id}`, payload);
        return response;
    } catch (error) {
        console.error('Update pickup zone error:', error);
        return error;
    }
};

export const deletePickupZone = async (id) => {
    try {
        const response = await api.delete(`/admin/pickup-zones/${id}`);
        return response.data;
    } catch (error) {
        console.error('Delete pickup zone error:', error);
        return error;
    }
};